export const SALES_SUPPORT = {
  FETCH_CONTACTS: (metadataid) => `/messagecontact/metadataid/${metadataid}/getcontacts`,
  FETCH_MESSAGES: (metadataid, phone) => `/message/metadataid/${metadataid}/phone/${phone}`,
  SEND_MESSAGE: (metadataid) => `/message/metadataid/${metadataid}/sendMessage`,
  SEND_REACTION: (metadataid) => `/message/metadataid/${metadataid}/react`,
  RESET_UNREAD_COUNTS: (metadataid, phone) =>
    `/messagecontact/metadataid/${metadataid}/phone/${phone}/resetunreadcount`,
  INITIATE_CALL: (metadataid, phone) =>
    `/message/metadataid/${metadataid}/phone/${phone}/initiatecall`,
  RECEIVE_CALL: (metadataid, phone) =>
    `/message/metadataid/${metadataid}/phone/${phone}/acceptcall`,
  TERMINATE_CALL: (metadataid, phone) =>
    `/message/metadataid/${metadataid}/phone/${phone}/terminatecall`,
};

export const TEMPLATE = {
  GET_TEMPLATE: (metadataid) => `/template/metadataid/${metadataid}`,
  CREATE_TEMPLATE: (metadataid) => `/template/metadataid/${metadataid}`,
  GET_TEMPLATE_BY_ID: (metadataid, templateID, templateName) =>
    `/template/metadataid/${metadataid}/templateid/${templateID}/templatename/${templateName}`,
  GET_TEMPLATE_LIBRARY: (metadataid) => `/template/metadataid/${metadataid}/messagetemplatelibrary`,
};

export const CAMPAIGN = {
  GET_CAMPAIGNS: (metadataId) => `/campaign/metadataid/${metadataId}`,
  CREATE_CAMPAIGN: (metadataId) => `/campaign/metadataid/${metadataId}`,
  GET_CAMPAIGN_BY_ID: (metadataId, campaignId) =>
    `/campaign/metadataid/${metadataId}/campaignid/${campaignId}`,
  GET_CAMPAIGNS_ANALYTICS: (metadataid, campaignId) =>
    `/campaign/metadataid/${metadataid}/campaignid/${campaignId}/analytics`,
};

export const WCA_SETTINGS = {
  /* ================= CALL SETTINGS ================= */

  GET_CALL_SETTINGS: (metadataid) => `/metadata/${metadataid}/callsettings`,

  SET_CALL_SETTINGS: (metadataid) => `/metadata/${metadataid}/callsettings`,

  /* ================= WHATSAPP PROFILE ================= */

  GET_WHATSAPP_PROFILE: (metadataid) => `/metadata/${metadataid}/whatsappprofile`,

  SET_WHATSAPP_PROFILE: (metadataid) => `/metadata/${metadataid}/whatsappprofile`,

  UPLOAD_PROFILE_PICTURE: (metadataid) => `/metadata/${metadataid}/resumableUpload`,
};

export const WCA_BOTFLOW = {
  ROOT: () => `/botflow`,
  BY_ID: (id) => `/botflow/${id}`,
  PUBLISH: (id) => `/botflow/${id}/publish`,
  SCHEMA: (id) => `/botflow/${id}/schema`,
  SCHEMA_VERSION: (id, version) => `/botflow/${id}/schema/${version}`,
};

export const TELEGRAM = {
  FETCH_BOT_CONFIGS: () => `/botconfig`,
  ADD_BOT_CONFIG: () => `/botconfig`,
  DELETE_BOT_CONFIG: (botId) => `/botconfig/${botId}`,
  FETCH_CONTACTS: (botConfigId) => `/messagecontact/botconfigid/${botConfigId}/getcontacts`,
  FETCH_MESSAGES: (botConfigId, chatId) => `/message/botconfigid/${botConfigId}/chatid/${chatId}`,
  SEND_MESSAGE: (botConfigId, chatId) =>
    `/message/botconfigid/${botConfigId}/chatid/${chatId}/sendMessage`,
  RESET_UNREAD_COUNTS: (botconfigid, chatid) =>
    `/messagecontact/botconfigid/${botconfigid}/chatid/${chatid}/resetunreadcount`,
};

export const METADATA = {
  GET_METADATA: `/metadata`,
  GET_METADATA_BY_ID: (metadataId) => `/metadata/${metadataId}`,
  CREATE_METADATA: `/metadata/onboard`,
};

export const PRODUCT = {
  GET_CATALOGUE: (catalogID) => `/catalog/catalogid/${catalogID}`,
  GET_CATALOGUE_BY_METADATA_ID: (metadataID) => `/catalog/metadataid/${metadataID}`,
  POST_CONNECT_CATALOGUE_TO_METADATA: (metadataID) => `/catalog/metadataid/${metadataID}/connect`,
  DELETE_DISCONNECT_CATALOGUE_FROM_METADATA: (metadataID) =>
    `/catalog/metadataid/${metadataID}/disconnect`,
  GET_PRODUCTS: (metadataId) => `/catalog/metadataid/${metadataId}/products`,
  POST_PRODUCT: (metadataId) => `/catalog/metadataid/${metadataId}/products`,
};

// endpoints.js

export const INSIGHT_ENDPOINTS = {
  GET_PRICING_ANALYTICS: (metadataId, fromDate, toDate) =>
    `/insight/metadataid/${metadataId}/pricinganalytics?fromDate=${fromDate}&toDate=${toDate}`,

  GET_MESSAGE_ANALYTICS: (metadataId, fromDate, toDate) =>
    `/insight/metadataid/${metadataId}/messageanalytics?fromDate=${fromDate}&toDate=${toDate}`,
};
